import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { FiX } from "react-icons/fi";

export default function EditTrainingTypeModal({
  show,
  onHide,
  data,
  onSave,
}) {
  const [form, setForm] = useState({});

  useEffect(() => {
    setForm(data || {});
  }, [data]);

  if (!data) return null;

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      {/* HEADER */}
      <div
        style={{
          padding: "15px 20px",
          borderBottom: "1px solid #e5e7eb",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <h5 style={{ fontWeight: 600 }}>Edit Training Type</h5>

        <div
          onClick={onHide}
          style={{
            width: 30,
            height: 30,
            borderRadius: "50%",
            background: "#f3f4f6",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
          }}
        >
          <FiX />
        </div>
      </div>

      {/* BODY */}
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Type</Form.Label>
            <Form.Control
              value={form.type || ""}
              onChange={(e) =>
                setForm({ ...form, type: e.target.value })
              }
              style={inputStyle}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={form.description || ""}
              onChange={(e) =>
                setForm({ ...form, description: e.target.value })
              }
              style={inputStyle}
            />
          </Form.Group>

          <Form.Group>
            <Form.Label>Status</Form.Label>
            <Form.Select
              value={form.status || "Active"}
              onChange={(e) =>
                setForm({ ...form, status: e.target.value })
              }
              style={inputStyle}
            >
              <option>Active</option>
              <option>Inactive</option>
            </Form.Select>
          </Form.Group>
        </Form>
      </Modal.Body>

      {/* FOOTER */}
      <div
        style={{
          padding: 15,
          borderTop: "1px solid #e5e7eb",
          display: "flex",
          justifyContent: "flex-end",
          gap: 10,
        }}
      >
        <Button
          onClick={onHide}
          style={{
            background: "#f3f4f6",
            border: "none",
            color: "#333",
          }}
        >
          Cancel
        </Button>

        <Button
          onClick={() => onSave(form)}
          style={{
            background: "#f97316",
            border: "none",
          }}
        >
          Save Changes
        </Button>
      </div>
    </Modal>
  );
}

const inputStyle = {
  background: "#f9fafb",
  border: "1px solid #e5e7eb",
  borderRadius: 6,
};